export const visit = (vm, at) => {
at({ "pt-br": { "colorPicker": { "favorites": "Favoritos", "popover": { "mode": { "simple": "Simples", "advanced": "Avan\xE7ado" }, "edit": "Editar", "reset": "Redefinir para o padr\xE3o" } } } });
};